import React from 'react';
import { Link } from 'react-router-dom';
import { LogoFooterSvg } from '../../svg';

export default function FooterContacts() {
    return (
        <div className="site-footer__widget footer-contacts">
            <div className="footer-brand">
                <Link to="/" className="footer-brand__logo" aria-label="Hokky Bangunan">
                    <img
                        src={`${process.env.PUBLIC_URL || ''}/images/logo-footer.png`}
                        alt="Hokky Bangunan"
                        className="footer-logo-img"
                    />
                </Link>
                <p className="footer-brand__desc">
                    Supermarket Bahan Bangunan terlengkap dan terpercaya untuk segala kebutuhan renovasi dan konstruksi Anda.
                </p>
            </div>

            <ul className="footer-info-list">
                <li className="footer-info-item">
                    <i className="fas fa-map-marker-alt footer-info-icon" />
                    <span>Jl. Raya Menganti Karangan No.38, Babatan, Kec. Wiyung, Kota Surabaya, Jawa Timur 60227</span>
                </li>
                <li className="footer-info-item">
                    <i className="far fa-clock footer-info-icon" />
                    <span>Setiap Hari: 07:30 – 21:30 WIB</span>
                </li>
            </ul>
        </div>
    );
}
